/**
 * Range Log standalone route.
 *
 * Mounts the v137 RangeView under the standard forge-nav. RangeView is
 * the practice session logger + auto-diagnose + PBs + streaks surface
 * (one of the headline paid-tier features). It pulls in a lot of
 * v137 dependencies — Card / Button / EmptyState UI primitives, lucide
 * icons, the diagnose engine, achievements, share builders, cloud sync.
 *
 * Theming matches Tune Wizard — dark background, ember accent, the
 * Tailwind utilities scoped through tune.css's Tailwind directives.
 * The Range entry re-uses tune.css so it ships the same Tailwind layer
 * (no separate Tailwind bundle).
 */

import { useSetups } from '@/hooks/useSetups';
import { RangeView } from './RangeView';
import '../tuning/tune.css';

export function RangePage() {
  const setups = useSetups();

  return (
    <div className="tune-page">
      <nav className="forge-nav">
        <a href="https://sparrowexpeditions.com/pages/the-forge" target="_top">The Forge</a>
        <a href="/wind-drift.html">Wind-Drift</a>
        <a href="/build-review.html">Build Review</a>
        <a href="/tune.html">Tune Wizard</a>
        <a href="/range.html" className="active">Range Log</a>
        <a href="/bows.html">My Bows</a>
        <a href="/arrows.html">My Arrows</a>
        <a href="/spine.html">Spine</a>
        <a href="/pages/methods#ashby" target="_blank" rel="noopener">Methods</a>
      </nav>

      <div className="tune-shell">
        <RangeView setups={setups} />
      </div>
    </div>
  );
}
